export const STRIPE_ROUTE_CHANGED_MESSAGE =
  'Der Auszahlungsstatus des Hosts hat sich geändert. Bitte lade die Seite neu und versuche es erneut.';

const normalizeAccountId = (value) => {
  if (!value) return null;
  return String(value);
};

export const getReservationStripeRoute = (reservation) => {
  if (typeof reservation?.usesConnect !== 'boolean') {
    return null;
  }

  const canUseConnect = reservation.usesConnect === true;
  return {
    canUseConnect,
    stripeConnectAccountId: canUseConnect
      ? normalizeAccountId(reservation.stripeConnectAccountId)
      : null,
    payoutMode: canUseConnect ? 'DESTINATION_CHARGE' : 'PLATFORM_HELD',
  };
};

export const getReservationStripeRouteMismatch = ({
  reservation,
  canUseConnect,
  stripeConnectAccountId,
}) => {
  // Backwards-compatible during deployment: old API responses do not include the
  // server-selected payment route yet. Once deployed, this becomes the hard guard.
  if (typeof reservation?.usesConnect !== 'boolean') {
    return {
      hasServerRoute: false,
      matches: true,
      routeMismatch: false,
      accountMismatch: false,
      payoutModeMismatch: false,
    };
  }

  const expectedUsesConnect = Boolean(canUseConnect);
  const serverUsesConnect = reservation.usesConnect === true;
  const expectedPayoutMode = expectedUsesConnect ? 'DESTINATION_CHARGE' : 'PLATFORM_HELD';
  const expectedAccountId = expectedUsesConnect ? normalizeAccountId(stripeConnectAccountId) : null;
  const serverAccountId = serverUsesConnect
    ? normalizeAccountId(reservation.stripeConnectAccountId)
    : null;

  const routeMismatch = serverUsesConnect !== expectedUsesConnect;
  const accountMismatch = serverAccountId !== expectedAccountId;
  const payoutModeMismatch = Boolean(
    reservation.payoutMode && reservation.payoutMode !== expectedPayoutMode
  );

  return {
    hasServerRoute: true,
    matches: !(routeMismatch || accountMismatch || payoutModeMismatch),
    routeMismatch,
    accountMismatch,
    payoutModeMismatch,
  };
};

export const reservationMatchesStripeRoute = (params) => (
  getReservationStripeRouteMismatch(params).matches
);

export const assertReservationMatchesStripeRoute = (params) => {
  const {
    routeMismatch,
    accountMismatch,
    payoutModeMismatch,
  } = getReservationStripeRouteMismatch(params);

  if (routeMismatch || accountMismatch || payoutModeMismatch) {
    throw new Error(STRIPE_ROUTE_CHANGED_MESSAGE);
  }
};
